import React, { Suspense } from "react";

export default function SuspenseLoad({ children }: any) {
  return <Suspense fallback={<>...</>}>{children}</Suspense>;
}
